import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { generateTempFieldId } from 'utils/idUtils';

export default class FieldInserter extends Component {
  state = {
    showInserters: false,
  }

  displayTimeout = null;

  onMouseEnter = () => {
    if (this.displayTimeout) {
      clearTimeout(this.displayTimeout);
    }
    this.displayTimeout = setTimeout(() => {
      this.setState({ showInserters: true });
    }, 300);
  }

  onMouseLeave = () => {
    if (this.displayTimeout) {
      clearTimeout(this.displayTimeout);
    }
    if (this.state.showInserters) {
      this.setState({ showInserters: false });
    }
  }

  addField = () => this.props.addField(generateTempFieldId(), this.props.index);

  toggleInserters = (shouldShow) => this.setState(() => ({ showInserters: shouldShow }))

  render() {
    return (
      <div
        className={`d-flex justify-content-center position-relative field-inserters ${this.state.showInserters ? 'show' : ''}`}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm px-5 mx-4"
          onClick={this.addField}
        >
          + Add Field
        </button>
      </div>
    );
  }
}
FieldInserter.propTypes = {
  index: PropTypes.number.isRequired,
  addField: PropTypes.func.isRequired,
};
